export const openingDuration = 150;

export const drawerWidth = 309;
